export default __webpack_public_path__ + "static/media/document.164920b4.jpg";